import { render, staticRenderFns } from "./pipelines_artifacts.vue?vue&type=template&id=5d82aaf2&"
import script from "./pipelines_artifacts.vue?vue&type=script&lang=js&"
export * from "./pipelines_artifacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports